import { render, staticRenderFns } from "./BiobankExplorerContainer_EIBIC.vue?vue&type=template&id=2f6a20fc&"
import script from "./BiobankExplorerContainer_EIBIC.vue?vue&type=script&lang=js&"
export * from "./BiobankExplorerContainer_EIBIC.vue?vue&type=script&lang=js&"
import style0 from "./BiobankExplorerContainer_EIBIC.vue?vue&type=style&index=0&id=2f6a20fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports